export const storages = {
	label: "Inventarios",
	search: "Busque un inventario",
	newStorage: "Nuevo inventario",
	storageName: "Nombre del inventario",
	removeStorage: "Eliminar inventario",
	editStorage: "Editar inventario",
	createStorage: "Crear inventario",
	addNewStorage: "Agregar nuevo inventario",
	zeroBackoffice: "Agotar todos los productos en inventario",
	deleteAllProducts: "Eliminar todos los productos",
	modalTransfer: "Transferir productos de {{storage}}",
	confirmMessage: "¿Está seguro que desea eliminar este inventario?",
	transferResume: "Informe de transferencia",
	storageList: {
		central: "General",
		default: "Local",
		emptyMessage: "Sin elementos para mostrar",
		emptyArea: "Sin inventarios para mostrar",
	},
	storageCard: {
		productSearch: "Busque por un producto",
		addProduct: "Agregar producto",
		edit: "Editar inventario",
		transfer: "Transferir productos",
		error: "No es posible {{action}} producto con cantidad 0",
		modal: {
			addProducts: "Agregar productos",
			removeProducts: "Eliminar productos",
			amount: "Ingrese la cantidad que desea",
			add: "agregar y su precio de costo unitario",
			count: "Cantidad",
			costValue: "Precio de costo",
			note: "Observación",
		},
		modalTransfer: {
			title: "Transferir {{name}}",
			okText: "Transferir",
			storage: "Inventario",
			quantity: "Cantidad",
			error: {
				selectStorage: "Seleccione un inventario",
				selectCount: "Seleccione una cantidad",
			},
		},
	},
	addProductModal: {
		title: "Agregar Productos",
		manual: {
			label: "Manualmente",
			product: "Producto",
			quantity: "Cantidad",
			costValue: "Precio de costo",
			addOtherProduct: "Agregar otro producto",
			error: {
				zeroCount: "No es posible agregar producto con cantidad 0",
				noneValidProduct: "Ningún producto válido seleccionado",
			},
		},
		xml: {
			label: "Importar XML",
			upload: "Haga clic o arrastre archivos para subir",
		},
		noteInfo: {
			error: "Algún problema con la factura ocurrió y no fue posible crear el Proveedor",
			title: "Datos de la Factura Fiscal",
			number: "Número de la factura",
			series: "Serie",
			operationType: "Naturaleza de la Operación",
			accessKey: "Clave de acceso",
			unavailable: "Indisponible",
			supplierName: "Emisor",
			cpnj: "CNPJ",
			addSupplier: "Agregar emisor a sus favoritos",
			totalValue: "Valor total",
			removeBill: "Eliminar cuenta por pagar",
			addBill: "Agregar cuenta por pagar",
			bill: "Cuenta",
			provider: "Proveedor",
		},
		form: {
			successNotification: "Datos importados",
			addedProducts: "Productos Agregados",
			submit: "Finalizar importación",
		},
		product: {
			label: "Producto",
			code: "SKU",
			description: "Descripción del producto",
			commercialQuantity: "Cant",
			commercialUnit: "Un",
			unitValue: "Precio unitario",
			equals: "equivale a",
			cost: "Precio de costo por",
			skip: "Saltar",
		},
	},
	transferProductModal: {
		transferFor: {
			label: "Transferir para",
			local: "Inventario Local",
			central: "Inventario General",
			placeSelect: {
				label: "Local de destino",
				placeholder: "Seleccione un local",
			},
		},
		destinyStorage: {
			label: "Inventario de destino",
			placeholder: "Seleccione un inventario",
		},
		product: {
			label: "Producto",
			placeholder: "Seleccione un producto",
		},
		quantity: "Cantidad",
		table: {
			product: "Producto",
			quantity: "Cantidad",
			unityCost: "Costo Unitario",
			totalCost: "Costo Total",
			empty: "Sin productos seleccionados",
		},
		error: {
			addProduct: "Producto no puede ser agregado sin cantidad",
			selectProduct: "Cantidad en inventario negativa. Producto no pudo ser seleccionado",
		},
		printTransfer: {
			title: "Comprobante de transferencia",
			text:
				"Este documento comprueba la transferencia de productos del inventario {{fromStorage}} para el inventario {{toStorage}}. El día {{date}} hecha por {{employee}}. Los productos transferidos están en la siguiente lista:",
			quantity: "Cantidad",
			withoutName: "Sin nombre",
			responsible: "Responsable por el inventario destino",
			successNotification: "Productos asociados y transferidos",
			notFound: "No encontrado",
			sheet: {
				filename: "transferencia-inventario",
				title: "Transferencia del inventario {{selectedStorage}} para {{toStorage}}",
				columns: {
					name: "Producto",
					count: "Cantidad",
					unit: "Unidad",
					unitaryCost: "Costo Unitario",
					totalCost: "Costo Total",
				},
			},
			infoText:
				"Transferencia realizada con éxito, vea abajo el resumen de los productos transferidos",
			none: "Ninguno",
			print: "Imprimir Doc. de transferencias",
			download: "Descargar Excel de transferencias",
			notTrasnfer: "Los siguientes productos no pudieron ser transferidos",
			unassociated: "No están asociados al local de destino",
			associate: "Haga clic aquí para asociarlos",
		},
	},
	tableProducts: {
		columns: {
			name: "Producto",
			category: "Categoría",
			count: "Cantidad",
			actions: "Acciones",
		},
		product: "Producto",
		quantity: "Cantidad",
		cost: "Precio de costo",
		add: "Agregar producto",
		total: "en total",
		productError: "Producto no encontrado",
		countError: "No es posible agregar producto con cantidad 0",
	},
	deleteProduct: {
		tooltip: "Eliminar producto",
		title: "¿Está seguro que desea eliminar este producto?",
	},
	error: "Error al actualizar inventarios",
	modalImportInvoice: {
		errors: {
			notKeyAccess: "No fue posible traer la clave de acceso XML",
		},
		placeholders: {
			selectStorage: "Seleccionar inventario",
		},
		labelInputs: {
			storage: "Inventario",
			xmlKey: "Clave XML",
		},
		typeOptionsImport: {
			xmlFile: "Adjuntar archivo XML",
			xmlKeyAccess: "Insertar clave de acceso del XML",
		},
		validationMessage: {
			emptySelectTypeImport: "Seleccione una opción de importación",
			emptyStorage: "Seleccione un inventario",
			emptyXmlKey: "Campo de Clave de Acceso vacío",
			emptyFileXml: "Archivo XML no seleccionado",
		},
	},
};
